import { useState } from 'react';
import SectionHeading from './SectionHeading';
import { scenarioTabs } from '@/mocks/homeData';

export default function HowToFind() {
  const [active, setActive] = useState(scenarioTabs[0].id);
  const current = scenarioTabs.find((t) => t.id === active) ?? scenarioTabs[0];

  return (
    <section id="howto" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <SectionHeading
            eyebrow="查找最新地址"
            title="不同场景下，应该怎么找到当前入口"
            desc="下面按「首次访问、日常访问、地址失效时」三种情景分别说明。切换标签即可查看对应步骤，全部内容都在本页中，无需跳转。"
          />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-10">
            <div className="lg:col-span-2">
              <div className="inline-flex flex-wrap gap-1 p-1 rounded-full bg-background-200">
                {scenarioTabs.map((tab) => (
                  <button
                    key={tab.id}
                    type="button"
                    onClick={() => setActive(tab.id)}
                    aria-pressed={active === tab.id}
                    className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                      active === tab.id
                        ? 'bg-primary-500 text-background-50'
                        : 'text-foreground-700 hover:text-primary-700'
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              <p className="mt-4 text-sm text-foreground-500">{current.hint}</p>

              <ol className="mt-6 space-y-4">
                {current.steps.map((step, idx) => (
                  <li
                    key={step.title}
                    className="flex gap-4 rounded-lg border border-background-200 bg-background-100 p-5"
                  >
                    <span className="flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-full bg-accent-500 font-heading text-sm font-bold text-background-50">
                      {idx + 1}
                    </span>
                    <div>
                      <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                        {step.title}
                      </h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
                    </div>
                  </li>
                ))}
              </ol>
            </div>

            <div className="flex flex-col gap-4">
              <div className="w-full h-[220px] md:h-[260px] rounded-lg overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20of%20warm%20amber%20light%20trails%20and%20layered%20translucent%20shapes%20suggesting%20connection%20and%20navigation%2C%20cream%20background%20with%20ochre%20and%20terracotta%20accents%2C%20minimal%20editorial%20style%2C%20generous%20negative%20space%2C%20no%20text&width=1000&height=1200&seq=cupfox-guide-01&orientation=portrait"
                  alt="暖色光线轨迹构成的抽象图形，象征入口线索的连接与查找"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="rounded-lg border border-background-200 bg-background-100 p-5">
                <div className="flex items-center gap-2">
                  <i className="ri-lightbulb-flash-line text-lg text-primary-600"></i>
                  <span className="font-heading text-sm font-semibold text-foreground-950">小提示</span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  查找时可先回到自己保存过的发布页，再按最新说明定位当前入口。相比在搜索引擎里反复碰运气，
                  这种方式更不容易误入仿冒页面。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}